var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.message)?_c('div',[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e(),(_vm.displayPage)?_c('div',[_c('Form',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isPreviewMode),expression:"!isPreviewMode"}],attrs:{"deal":_vm.dealData,"deal-id":_vm.dealId}}),(_vm.isPreviewMode)?_c('FormPreview'):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }